<template>

  <div>
    <div class="custom-row">
      <div class="custom-col custom-col--66 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_PackagingExternalWarning'])"></div>
        <WarningStatic class="mw-100 w-100" :type="'yellow'">
          <template slot="text">
            {{$t('fbm_PackagingExternalWarning.localization_value.value')}}
          </template>
        </WarningStatic>
      </div>
    </div>

    <div class="order-create__row custom-row">
      <div class="order-create__col custom-col custom-col--sm-50 custom-col--wfc"
           v-if="isAdmin"
      >
        <RadioDefault
            :label="'None'"
            name="fedexRadioList23"
            :value="FBM.data.packagingType === ''"
            @input="changePackageType('')"
        />
      </div>
      <template v-for="(item, index) in $store.getters.getPackagingTypes">
        <div class="order-create__col custom-col custom-col--sm-50 custom-col--wfc d-flex"
             v-if="checkVisible(item)"
             :key="index"
             v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editPopup(item)"></div>
          <RadioDefault
              class="wfc"
              :label="item.currentTranslate.name"
              name="fedexRadioList23"
              :value="checkActiveCheckbox(item)"
              @input="changePackageType(item); setPackingPriceDimensions(FBM.data.packagingTypePrice)"
          />

          <v-popover
              class="site-tooltip site-tooltip--radio-after"
              :disabled="!tooltipAddProductActive"
              offset="5"
              placement="top-left"
              trigger="hover"
          >

            <TooltipBtn/>

            <template slot="popover">
              <div class="box-tooltip">
                <div class="box-tooltip__img">
                  <img style="max-width: 56px"
                       v-if="item.file_entity && Object.keys(item.file_entity).length && item.file_entity['file_url']" :src="item.file_entity['file_url']"
                       alt="img">
                  <img v-else src="/img/common/box-img.png" alt="img">
                </div>
                <div class="box-tooltip__content">
                  <p>
                    <b>{{item.currentTranslate.name}}</b>
                  </p>
                  <p v-html="item.currentTranslate.description">

                  </p>
                </div>
              </div>

            </template>
          </v-popover>
        </div>
      </template>

      <PackingTypeEditPopup
          v-if="isActiveEditPopup"
          :item="itemEdit"
          @close="closeEditPopup"
      />
    </div>

    <template v-if="isWarehouse">
      <template v-for="(item, index) in $store.getters.getPackagingTypes">
        <div class="order-create__toggle-block toggle-block small-size"
             v-if="checkActiveCheckbox(item) && getActivePackingPrices(item).length > 0"
             :key="'packingPrices' + index">
          <div class="toggle-block__details">
            <div class="toggle-block__details-head">
              <div class="toggle-block__details-title"
                   v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['fbm_PackagingSizes'])"></div>
                <span>{{$t('fbm_PackagingSizes.localization_value.value')}}</span>
              </div>
            </div>

            <div class="toggle-block__details-body">
              <div class="custom-row">
                <div class="custom-col mb-2">
                  <RadioDefault
                      v-for="(itemPackingPrices, indexPrice) in getActivePackingPrices(item)"
                      :key="indexPrice"
                      class="mb-2"
                      :label="getPackingPriceLabel(itemPackingPrices)"
                      name="packingPricesRadio"
                      :value="FBM.data.packagingTypePrice && FBM.data.packagingTypePrice.id === itemPackingPrices.id"
                      @input="changePackageTypePrice(itemPackingPrices); setPackingPriceDimensions(itemPackingPrices)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>


    <div class="order-create__row custom-row" v-if="FBM.data.packagingTypePrices.length > 0">

      <div class="order-create__col custom-col mb-0">
        <div class="order-create__section-label section-label"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['fbm_PackagingPrices'])"></div>
          {{$t('fbm_PackagingPrices.localization_value.value')}}
        </div>
      </div>

<!--      <div class="order-create__col custom-col custom-col&#45;&#45;sm-50 custom-col&#45;&#45;wfc d-flex mb-2"-->
<!--           v-for="(item, index) in FBM.data.packagingTypePrices"-->
<!--           :key="index"-->
<!--           v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">-->
<!--        <RadioDefault-->
<!--            class="wfc"-->
<!--            :label="item.currentTranslate.name"-->
<!--            name="packagingTypePrice"-->
<!--            :value="FBM.data.packagingTypePrice.id && item.id === FBM.data.packagingTypePrice.id"-->
<!--            @input="changePackageTypePrice(item)"-->
<!--        />-->
<!--      </div>-->
    </div>


    <div class="order-create__toggle-block toggle-block small-size" v-if="FBM.data.packagingTypePrices.length > 0">
      <div class="toggle-block__type min-w-140">
        <div class="toggle-block__type-list">
          <div class="d-flex align-items-center mb-3"
               v-for="(item, index) in FBM.data.packagingTypePrices"
               :key="index"
               v-bind:class="{'admin-edit-item': isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editPopup(item)"></div>
            <RadioDefault
                class="wfc"
                :label="item.currentTranslate.name"
                name="packagingTypePrice"
                :value="FBM.data.packagingTypePrice.id && item.id === FBM.data.packagingTypePrice.id"
                @input="changePackageTypePrice(item)"
            />
          </div>
        </div>
      </div>

      <template  v-if="FBM.data.packagingTypePrice.sub_prices && FBM.data.packagingTypePrice.sub_prices.length > 0">
        <div class="toggle-block__details"
             id="packing-prices-block"
        >
          <div class="toggle-block__details-head">
            <div class="toggle-block__details-title">
              <span>Variants</span>
            </div>
          </div>

          <div class="toggle-block__details-body">
            <div class="custom-row">
              <div class="custom-col flex-column-reverse mb-2">
                <template
                    v-for="(item, index) in FBM.data.packagingTypePrice.sub_prices"
                >
                  <RadioDefault
                      :key="index"
                      class="mb-2"
                      :label="item.currentTranslate.name + ' & price: ' + item.price"
                      name="fedexRadioList23423"
                      :value="FBM.data.packagingTypePriceVariant.id === item.id"
                      @input="FBM.data.packagingTypePriceVariant = item"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
  import RadioDefault from "../../../../../../../UI/radiobuttons/RadioDefault/RadioDefault";
  import TooltipBtn from "../../../../../../../UI/tooltips/TooltipBtn/TooltipBtn";
  import PackingTypeEditPopup
    from "../../../../../../../coreComponents/Popups/PackingTypeEditPopup/PackingTypeEditPopup";
  import {FBMMixins} from "@/mixins/FBMMixins/FBMMixins";
  import WarningStatic from "@/components/UI/alerts/WarningStatic/WarningStatic";
  import {FBM_PACKING_TYPE_WAREHOUSE_DISCRETION_ID} from "@/staticData/staticVariables";
  export default {
    name: "Packaging",
    components: {WarningStatic, PackingTypeEditPopup, TooltipBtn, RadioDefault},

    mixins: [FBMMixins],

    props: {
      FBM: Object,
    },

    watch: {
      getUserDimensions() {
        console.log(445533);
        console.log(this.FBM.data.optionalForDimensionsChangesCount);
        console.log(this.FBM.getPackagingType());
        this.changePackageType(this.FBM.getPackagingType())
      },
      getUserInformation() {
        console.log(445533);
        console.log(this.FBM.data.optionalForDimensionsChangesCount);
        console.log(this.FBM.getPackagingType());
        this.changePackageType(this.FBM.getPackagingType())
      },
      getShippingAPIPrice() {
        if(this.FBM.data.shippingAPIPrice && Object.keys(this.FBM.data.shippingAPIPrice).length > 0 && this.FBM.data.shippingAPIPrice?.without_packing) {
          let foundPacking = false

          this.FBM.data.shippingAPIPrice?.without_packing.forEach(packing => {
            if(this.FBM.data.packagingType?.code === packing) {
              foundPacking = true
            }
          })

          if(foundPacking) {
            let availablePacking = this.$store.getters.getPackagingTypes.filter(p => !this.FBM.data.shippingAPIPrice.without_packing.includes(p.code))
            this.changePackageType(availablePacking[0])
          }
        }
      },
    },

    computed: {
      getUserDimensions() {
        return this.FBM.data.optionalForDimensionsChangesCount
      },
      getShippingAPIPrice() {
        return this.FBM.data.shippingAPIPrice
      },
      getUserInformation() {
        return this.FBM.data.Personal.information.personalName +
            this.FBM.data.DeliveryPayPal.delivery.address +
            this.FBM.data.DeliveryPayPal.delivery.city +
            this.FBM.data.DeliveryPayPal.delivery.region +
            this.FBM.data.DeliveryPayPal.delivery.country?.id +
            this.FBM.data.DeliveryPayPal.delivery.zip
      },
    },

    data() {
      return {
        tooltipAddProductActive: true,

        isActiveEditPopup: false,
        itemEdit: {}
      }
    },

    mounted() {
      this.getPacking()
    },

    methods: {

      getPacking() {
        let type = this.isConsolidation ? '/user-consolidation-list' : this.isLabel ? '/user-create-label-list' : ''

        this.$store.dispatch('getDeliveryPackingType', type).then((response) => {
          let data = this.getRespPaginateData(response)
          if(!this.FBM.data.packagingType?.id){
            this.changePackageType(data[0])
            this.setPackingPriceDimensions(this.FBM.data.packagingTypePrice)
          }
          // else if(this.isConsolidation && this.FBM.data.packagingTypePrices.length === 0) {
          //   this.changePackageType(this.FBM.data.packagingType, true)
          // }
        })
      },

      checkVisible(item) {
        if(item.id === FBM_PACKING_TYPE_WAREHOUSE_DISCRETION_ID) return false

        if(this.FBM.data.shippingAPIPrice?.without_packing) {
          return !this.FBM.data.shippingAPIPrice?.without_packing.includes(item.code)
        } else {
          return true
        }
      },

      changePackageType(item, onlyLoad = false) {
        this.FBM.setPackagingType(item)

        if(this.isConsolidation || this.isLabel) {
          if(this.FBM.data.popularMethodsType) {
            this.getPopularMethods()
          } else {
            this.getShippingPrices()
          }
        }

        if(item?.fetch_packaging_prices_for_user && this.isConsolidation) {

          let prepareFBM = this.FBM.prepareFBM(false, false, false, this.isAdmin, true, false, false, true)

          let prepareData = {
            "user_id": prepareFBM.user_id,
            "order_type_id" : prepareFBM.order_type_id,
            "recipient_contact_name": prepareFBM.recipient_contact_name,
            "recipient_phone_number" : prepareFBM.recipient_phone_number,
            "recipient_company_name": prepareFBM.recipient_company_name,
            "recipient_email": prepareFBM.recipient_email,
            "recipient_address": prepareFBM.recipient_address,
            "recipient_address_1": prepareFBM.recipient_address_1,
            "recipient_city": prepareFBM.recipient_city,
            "recipient_region": prepareFBM.recipient_region,
            "recipient_country_id": prepareFBM.recipient_country_id,
            "recipient_zip_code": prepareFBM.recipient_zip_code,
            "insurance_amount" : prepareFBM.insurance_amount,
            "delivery_company_id" : prepareFBM.delivery_company_id,
            "delivery_method_id" : prepareFBM.delivery_method_id,
            "saturday_delivery" : prepareFBM.saturday_delivery,
            "require_signature" : prepareFBM.require_signature,
          }

          if(prepareFBM.storage_id) {
            prepareData['storage_id'] = prepareFBM.storage_id
          }

          if(this.isAdmin){
            prepareData["admin_dimension"] = prepareFBM.admin_dimension

            if(prepareFBM.delivery_date && prepareFBM.delivery_date !== ''){
              prepareData["delivery_date"] = prepareFBM.delivery_date
            }
          } else {
            prepareData["dimension"] = prepareFBM.dimension

            if(prepareFBM["saturday_delivery"] === 1 && this.getUserPlannedDate){
              prepareData["delivery_date"] = this.$moment(this.getUserPlannedDate).format('YYYY-MM-DD')
            }
          }

          /**
           * if user dimensions is empty -> return
           */
          if(!this.isAdmin && this._.first(prepareData["dimension"])?.weightKg === '' && this._.first(prepareData["dimension"])?.weightGr === '')
            return
          /**
           * if required fields is empty -> return
           */
          if(!prepareData.recipient_address ||
              !prepareData.recipient_city ||
              !prepareData.recipient_contact_name ||
              !prepareData.recipient_country_id ||
              !prepareData.recipient_region ||
              !prepareData.recipient_zip_code)
            return



          this.$store.dispatch('getDeliveryPackingTypePrices', {id: item.id, data: prepareData}).then((response) => {
            switch (this.getResponseStatus(response)) {
                /**
                 * Success
                 */
              case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
                let data = this.getRespPaginateData(response)
                this.FBM.data.packagingTypePrices = data
                if(data.length > 0 && !onlyLoad) {
                  this.changePackageTypePrice(data[0])
                } else if(this.FBM.data.packagingTypePrice?.id) {
                  this.FBM.data.packagingTypePrice = data.find(i => i?.id === this.FBM.data.packagingTypePrice.id)
                }
                break
              }
                /**
                 * Validation Error
                 */
              case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
                // let errors = response.response.data.errors;
                // this.notifyErrorHelper(errors)
                break
              }
                /**
                 * Undefined Error
                 */
              default: {
                this.openNotify('error', 'common_notificationUndefinedError')
              }
            }
          })

        } else if(this.isWarehouse) {
          this.FBM.data.packagingTypePrices = []
          // лишити вибрану ціну, якщо вона є в типу, інакше — першу
          let type = this._.find(this.$store.getters.getPackagingTypes, {id: item?.id})
          if(!item || type) {
            let prices = this.getActivePackingPrices(type)
            if(!this._.find(prices, {id: this.FBM.data.packagingTypePrice?.id})) {
              this.changePackageTypePrice(this._.first(prices) || '')
            }
          }
        } else {
          this.FBM.data.packagingTypePrices = []
          this.changePackageTypePrice('')
        }

      },

      changePackageTypePrice(item) {
        this.FBM.data.packagingTypePrice = item

        if(item.sub_prices && item.sub_prices.length > 0) {
          this.FBM.data.packagingTypePriceVariant = item.sub_prices[0]
        } else {
          this.FBM.data.packagingTypePriceVariant = ''
        }
      },

      getActivePackingPrices(item) {
        return (item?.user_packing_prices || []).filter(price => price.is_active)
      },

      // для warehouse підставити габарити з ціни пакування (у кг/см), без них — очистити
      setPackingPriceDimensions(price) {
        if(!this.isWarehouse) return
        let dimensions = this.getPackingPriceMetricDimensions(price)

        this.FBM.data.Dimensions.setDimensionsWeightLB(dimensions ? dimensions.weight : '')
        this.FBM.data.Dimensions.setDimensionsWeightOZ('')
        this.FBM.data.Dimensions.setDimensionsHeight(dimensions ? dimensions.height : '')
        this.FBM.data.Dimensions.setDimensionsWidth(dimensions ? dimensions.width : '')
        this.FBM.data.Dimensions.setDimensionsLength(dimensions ? dimensions['length'] : '')
      },

      checkActiveCheckbox(item) {
        return this.FBM.data.packagingType?.id === item.id
      },

      editPopup(item){
        this.itemEdit = item
        this.isActiveEditPopup = true
      },

      closeEditPopup(){
        this.itemEdit = {}
        this.isActiveEditPopup = false
        this.getPacking()
      }

    }

  }
</script>

<style scoped>

</style>
